import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Navigate } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";

import Info from "./info";
import Payment from "./payment";

import api from "../../../services/api";
import useStore from "../../../store";

const INFO = "INFO";
const PAYMENTS = "PAYMENTS";

export default () => {
  const [values, setValues] = useState();
  const [tab, setTab] = useState(INFO);

  const { user } = useStore();

  const { id } = useParams();
  const navigate = useNavigate();

  // if (user.role !== "admin" && values?.assignee !== user.username) {
  //   return <Navigate to="/" />;
  // }

  useEffect(() => {
    getCustomer();
  }, [id]);

  const getCustomer = async () => {
    try {
      const { data } = await api.get(`customer&id=${id}`);
      setValues(data);
    } catch (error) {
      console.error(error);
    }
  };

  if (!values) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6 flex items-center space-x-3">
        <AiOutlineArrowLeft
          className="cursor-pointer"
          onClick={() => navigate("/customer")}
        />
        <span>Customer Information</span>
      </h1>

      <div className="flex px-3">
        <Tab active={tab === INFO} onClick={() => setTab(INFO)} text="Info" />
        <Tab
          active={tab === PAYMENTS}
          onClick={() => setTab(PAYMENTS)}
          text="Payments"
        />
      </div>

      <div className="bg-white shadow-lg rounded-lg p-6">
        {tab === INFO && <Info values={values} setValues={setValues} />}
        {tab === PAYMENTS && <Payment customer={values} />}
      </div>
    </div>
  );
};

const Tab = ({ text, active, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`py-2 px-4 text-sm font-medium ${
        active
          ? "border-b-2 border-black text-black"
          : "text-gray-500 hover:text-black"
      }`}
    >
      {text}
    </button>
  );
};
